import { FC, ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { authStore } from '@/store/authStore'

interface PrivateRouteProps {
  children: ReactNode
}

/** Rota que exige login e, para quem ainda está em onboarding, desvia ao primeiro acesso. */
export const PrivateRoute: FC<PrivateRouteProps> = ({ children }) => {
  const { isAuthenticated, usuario } = authStore()
  const location = useLocation()

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  // Consultor em onboarding tem conta, mas nenhum papel que dê acesso a dados: solto no
  // dashboard ele veria só telas em erro 403 sem entender por quê. O desvio vale para
  // quem tem SOMENTE o papel de onboarding — quem já foi promovido segue normalmente.
  const papeis = (usuario?.permissoes ?? []).map((p) => p.toUpperCase())
  const somenteOnboarding =
    papeis.includes('CONSULTOR_ONBOARDING') &&
    !papeis.some((p) => ['CONSULTOR', 'OPERADOR', 'GERENTE', 'ADMIN'].includes(p))

  if (somenteOnboarding && location.pathname !== '/primeiro-acesso') {
    return <Navigate to="/primeiro-acesso" replace />
  }

  return <>{children}</>
}
